// src/redux/actions/cityActions.js
import {
    FETCH_CITY_REQUEST,
    FETCH_CITY_SUCCESS,
    FETCH_CITY_FAILURE,
    SET_SELECTED_CITY,
  } from '../types';
  import axios from '../../API/axios';
  
  export const fetchCityData = (searchTerm = '') => async (dispatch) => {
    dispatch({ type: FETCH_CITY_REQUEST });
  
    try {
      
      const response = await axios.get(`/MasterData/GetCitiesDDL?Search=${searchTerm}&CountryName=United Arab Emirates`);
      let cityList =response.data.responseData.map((val)=>{
        return{
          value:val.id,
          label:val.name,
        }
    })
      dispatch({
        type: FETCH_CITY_SUCCESS,
        payload: cityList,
      });
    } catch (error) {
      dispatch({
        type: FETCH_CITY_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const selectCity = (cityId) => ({
    type: SET_SELECTED_CITY,
    payload: cityId,
  });
  